// ===============================
// components/Common/FestiveShowcase.jsx
// ===============================

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "./FestiveShowcase.css";

const FestiveShowcase = ({
  tagline = "",
  title = "Special Collection ❤️",
  description = "Explore our exclusive range of personalized gifts and curated items made especially for your loved ones.",
  buttonText = "Shop The Collection",
  searchTag = "",
  limit = 2,
}) => {
  const [festiveProducts, setFestiveProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFestiveProducts = async () => {
      if (!searchTag || !searchTag.trim()) {
        setLoading(false);
        return;
      }

      try {
        const baseUrl = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
        const cleanTag = searchTag.replace(/\|\|/g, ",").trim();

        const res = await axios.get(
          `${baseUrl}/api/products?search=${encodeURIComponent(cleanTag)}&limit=${limit * 2}` // Fetch extra to account for filtered items
        );

        if (res.data.success) {
          // 🎯 FILTER LOGIC: Exclude custom/personalized products
          const regularProducts = (res.data.products || []).filter((product) => {
            const isCustom = 
              (product?.sku && product.sku.toUpperCase().startsWith("CUSTOM")) || 
              (Array.isArray(product?.tags) && product.tags.includes("personalized"));
            
            return !isCustom; // Keep only products that are NOT custom
          });

          // Safety slice to guarantee max limit items are rendered
          const productsToDisplay = regularProducts.slice(0, limit);
          setFestiveProducts(productsToDisplay);
        }
      } catch (error) {
        console.error("Error fetching festive products:", error);
        setFestiveProducts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchFestiveProducts();
  }, [searchTag, limit]);

  if (loading || festiveProducts.length === 0) return null;

  return (
    <section className="festive-showcase">
      <div className="container">
        <div className="festive-wrapper">
          {/* Left Banner Section */}
          <div className="festive-banner">
            {tagline && <span className="festive-tag">{tagline}</span>}
            <h2>{title}</h2>
            <p>{description}</p>
            <Link
              to={`/shop?search=${encodeURIComponent(searchTag.replace(/\|\|/g, " "))}`}
              className="festive-btn"
            >
              {buttonText}
            </Link>
          </div>

          {/* Right Products Section */}
          <div className="festive-products">
            {festiveProducts.map((product) => (
              <div className="festive-card" key={product._id}>
                <Link to={`/product/${product._id}`}>
                  <div className="festive-image-wrapper">
                    <img
                      src={product.image || product.images?.[0]}
                      alt={product.name}
                    />
                    {product.discount > 0 && (
                      <span className="festive-badge">-{product.discount}%</span>
                    )}
                  </div>
                  
                  <div className="festive-info">
                    <h4>{product.name}</h4>
                    <div className="festive-price">
                      <span className="current">₹{product.price}</span>
                      {product.originalPrice > product.price && (
                        <span className="original">₹{product.originalPrice}</span>
                      )}
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FestiveShowcase;